import { AfterViewInit, Component, ContentChildren, QueryList } from '@angular/core';

import { AutocompleteInputComponent } from '../autocomplete-input/autocomplete-input.component';

@Component({
    selector: 'ridango-ui-swappable-inputs',
    templateUrl: './swappable-inputs.component.html',
    styleUrls: ['./swappable-inputs.component.scss'],
})
export class SwappableInputsComponent implements AfterViewInit {
    @ContentChildren(AutocompleteInputComponent) inputs: QueryList<AutocompleteInputComponent>;

    isSwappable = false;



    ngAfterViewInit() {
        setTimeout(() => this.isSwappable = this.inputs.length === 2);
    }

    swap(): void {
        const first = this.inputs.first;
        const second = this.inputs.last;

        const temp = {
            input: first.input.value,
            option: first.selectedOption,
        };

        first.setInputValue(second.selectedOption);
        second.setInputValue(temp.option);
    }
}
